// ============================================================================
// doublonAdresse.js : une adresse e-mail est-elle déjà portée par une fiche ?
//
// Validation d'une demande de compte (App.jsx, relecture 3 du 30/09/2026) :
// l'ancien contrôle interrogeait Firestore par égalité stricte (la casse et les
// espaces d'une fiche ancienne échappaient au filtre) et écartait les fiches
// supprimées, si bien qu'une restauration ultérieure donnait deux fiches à la
// même clé de connexion et d'habilitation. On compare ici des adresses
// normalisées, e-mail ET alias, fiches supprimées ou inactives comprises.
// ============================================================================

/** Forme comparable d'une adresse : NFC, minuscules, sans aucun espace ni
 *  caractère invisible (espace de largeur nulle, trait d'union conditionnel,
 *  marques de sens : catégorie Unicode Cf), qui faisait passer un doublon. */
export const normAdresse = (e) => String(e || "").normalize("NFC").toLowerCase().replace(/[\s\p{Cf}]+/gu, "");

/** Fiches (actives ou non) dont l'e-mail ou un alias vaut `adresse`. */
export function fichesPortantAdresse(fiches, adresse) {
  const a = normAdresse(adresse);
  if (!a) return [];
  return (Array.isArray(fiches) ? fiches : []).filter((f) => f && (normAdresse(f.email) === a
    || (Array.isArray(f.emailAliases) && f.emailAliases.some((x) => normAdresse(x) === a))));
}

/** Motif de refus d'une création, ou "" quand l'adresse est libre. */
export function motifDoublon(fiches, adresse) {
  const a = normAdresse(adresse);
  if (!a) return "La demande n'a pas d'adresse e-mail : rien n'est créé.";
  const porteuses = fichesPortantAdresse(fiches, a);
  if (!porteuses.length) return "";
  const inactives = porteuses.filter((f) => f.supprime === true || f.actif === false);
  if (inactives.length === porteuses.length) {
    return `Une fiche supprimée ou inactive porte déjà l'adresse ${a} : rien n'est créé. Restaurez-la plutôt que d'en créer une seconde.`;
  }
  return `Une fiche porte déjà l'adresse ${a} : rien n'est créé. Vérifiez la demande (elle a pu être modifiée) ou complétez la fiche existante.`;
}
